import nhsOptionsMedium from './nhs-options-starscape-header-medium.svg'
import nhsOptionsSmall from './nhs-options-starscape-header-small.svg'
import defaultLarge from './starscape-header-large.svg'

const nhsOptionsHeroStarscapes = {
  xSmall: { url: nhsOptionsSmall, position: `top center` },
  small: { url: nhsOptionsMedium, position: `top center` },
  medium: { url: defaultLarge, position: `top right` },
}

export default nhsOptionsHeroStarscapes
